export default "__VITE_ASSET__CennsGLV__"